import Country from 'country-state-city/lib/country';

/**
 * Address country is stored on the API as the full country name (e.g. "United States"),
 * while the forms hold the ISO code (e.g. "US") so it can drive the State/Province options.
 * These helpers convert between the two, matching the guardian profile-edit convention.
 */

/** ISO code (form value) → country name (API value). Returns null when unset/unknown. */
export const countryCodeToName = (code?: string | null): string | null => {
  const trimmed = code?.trim();
  if (!trimmed) return null;
  return Country.getCountryByCode(trimmed)?.name ?? null;
};

/** Country name (API value) → ISO code (form value). Returns '' when unset/unknown. */
export const countryNameToCode = (name?: string | null): string => {
  const normalized = name?.trim().toLowerCase();
  if (!normalized) return '';
  return (
    Country.getAllCountries().find(country => country.name.toLowerCase() === normalized)?.isoCode ??
    ''
  );
};
